import React from 'react';
import { Link } from 'react-router-dom';

const AuthFormContainer = ({ title, children }) => {
    return (
        <div className="text-white flex flex-col items-center justify-center px-4 py-16 sm:py-24">
            <div className="w-full max-w-sm">
                <div className="rounded-2xl border border-white/10 bg-[#0b0e14]/60 backdrop-blur-sm p-8 shadow-2xl">
                    <h1 className="text-2xl font-bold text-center mb-6">{title}</h1>
                    {children}
                </div>
            </div>
        </div>
    );
};

export default AuthFormContainer;